import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=e162dd20&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=e162dd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e162dd20",
  null
  
)

export default component.exports